"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPatternSegments = void 0;

var _fancyRegex = require("fancy-regex");

const patternRegex = (0, _fancyRegex.regex)`
	^
		(\*|\w+)      # scheme
		://
		(
			\*     |  # Any host
			[^/]*     # Only the given host (optional only if scheme is file)
		)
		(/.*)         # path
	$
`;

const getPatternSegments = pattern => {
  if (pattern === '<all_urls>') {
    return {
      pattern,
      scheme: '*',
      rawHost: '*',
      rawPathAndQuery: '/*'
    };
  }

  const m = pattern.match(patternRegex);
  if (!m) return null;
  const [,
  /* fullMatch */
  scheme, rawHost, rawPathAndQuery] = m;
  return {
    pattern,
    scheme,
    rawHost,
    rawPathAndQuery
  };
};

exports.getPatternSegments = getPatternSegments;